// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-cta{display:flex;flex-direction:column;justify-content:center;align-items:center}.icon-cta__text{font-family:LaPrairie;text-transform:uppercase;color:#fff;font-weight:400;font-size:.6875rem;margin:1rem 0 0}.icon-cta__icon{width:48px;height:auto}", ""]);
// Exports
module.exports = exports;
